module.exports = __webpack_public_path__ + "img/banner3.e05ce55f.png";